var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17603_592)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 22H29.01M29 28C32.3137 28 35 25.3137 35 22C35 18.6863 32.3137 16 29 16C25.6863 16 23 18.6863 23 22C23 22.2737 23.0183 22.5431 23.0538 22.807C23.1122 23.2412 23.1414 23.4583 23.1217 23.5956C23.1013 23.7387 23.0752 23.8157 23.0047 23.9419C22.937 24.063 22.8177 24.1823 22.5791 24.4209L17.4686 29.5314C17.2957 29.7043 17.2092 29.7908 17.1474 29.8917C17.0925 29.9812 17.0521 30.0787 17.0276 30.1808C17 30.2959 17 30.4182 17 30.6627V32.4C17 32.9601 17 33.2401 17.109 33.454C17.2049 33.6422 17.3578 33.7951 17.546 33.891C17.7599 34 18.0399 34 18.6 34H20.3373C20.5818 34 20.7041 34 20.8192 33.9724C20.9213 33.9479 21.0188 33.9075 21.1083 33.8526C21.2092 33.7908 21.2957 33.7043 21.4686 33.5314L26.5791 28.4209C26.8177 28.1823 26.937 28.063 27.0581 27.9953C27.1843 27.9248 27.2613 27.8987 27.4044 27.8783C27.5417 27.8586 27.7588 27.8878 28.193 27.9462C28.4569 27.9817 28.7263 28 29 28Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17603_592",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17603_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17603_592",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.1aa1e58434f16d70b6b96dba2c52902c.svg";
export { ForwardRef as ReactComponent };